@if (active) {
<div class="floating-indicator" (click)="onClick()" role="button" aria-label="Descargas en curso">
    <div class="circle">
        <mat-progress-spinner 
            [mode]="'determinate'"
            [value]="progress"
            diameter="56"
            strokeWidth="6">
        </mat-progress-spinner>
        <div class="percent">{{ progress }}%</div>
    </div>
</div>
}